module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagec",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/chapimg.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CTitle"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")]), _vm._v(" "), _c('p', {
    staticClass: "CTitle1"
  }, [_c('strong', [_vm._v("THE WORKINGS OF FACEBOOK MARKETING, GUERRILLA STYLE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Facebook, a modern social media tool like no other, has changed the way guerrillas launch online marketing campaigns today. It is free, accessible and easy-to-navigate, and it has levelled the playing field between the haves and the have-nots in terms of marketing budgets and resources. Facebook has helped many businesses generate market leads, build lists, expand customer base, increase sale conversions, and boost repeat customer sales.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, Facebook has also been misunderstood by many. Many businesses are eager to join the bandwagon and connect with their fans, but without a deep understanding of how marketing works within the context of Facebook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is where we start. We put things in perspective by first highlighting the unique attributes and attitudes that could help "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("you understand better how Guerrilla Facebook Marketing works. Facebook is a unique social media tool. It goes beyond the other social media tools, and offers great marketing potential for guerrillas. Appreciating its uniqueness can help us approach this amazing marketing medium better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this Chapter, we have identified ten such attributes of Facebook and ten attitudes of Guerrilla Facebook Marketers. Attributes are features or qualities that are regarded as characteristics of Facebook – you could call it an overview of Facebook culture from a guerrilla’s point of view if you like. Attitudes are based on your beliefs – your ways of thinking that guerrilla marketers would want to emulate – you could call it guerrilla coping strategies for Facebook Marketing.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "ch1-sec1"
    }
  }, [_c('strong', [_vm._v("Attributes of Facebook")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("1. Authentic Conversations")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrillas value substance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Facebook’s platform was designed to help you generate authentic conversations. You can build trust, invest in communication, and pay regular attention to your customers through Facebook’s many ways of communicating and interacting. This is the core of Facebook and this is how businesses connect their brands with their customers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The web community is very discerning. This is a community that is not just interested in entertaining spectacles like flashy advertisements or clever copywriting. Facebook Marketing is your chance to expand the way the community see your business. You achieve this by letting them know who you are, and what your brand stands for. The beauty of Facebook and its community is that the community too wants to see if they can identify with your "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("values and opinions. In other words, they are looking for authentic conversations with brands they feel connected with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Customers today, more than ever, buy the promise of fulfilling hopes and dreams. They are not just buying a product or service, they are buying ambition, acceptance, beauty, confidence, convenience, comfort, friendship, gratification, health, independence, love, security, wealth, success . . . A brand, therefore, should also be treated as a promise. It is a promise that you, the business owner, make to your customers. And because your customers would buy based on your promise, you are obliged to uphold that promise with the respect it deserves. Businesses who understand this have harnessed the power of Facebook to reach out to their customers, and to build their brand reputation further and deeper with their customers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the power of authentic conversations in Facebook.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("2. Likeable Content")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrilla Marketing is based on the science of human psychology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are two aspects that can make something likeable:")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber1"
  }, [_vm._v("1. how something is expressed, and")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("2. how relevant and/or appealing the content is to the audience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("90% of purchasing decisions are guided by the unconscious mind. When a customer likes a brand, it is because the brand has consistently spoken in ways that appeals to the customer’s unconscious mind. How you express yourself to your fans and customers is important. What do you want your Facebook Profile or Page to say about your business? Is your content compelling? Authentic? Genuine? Newsworthy? Delightful? Humorous? Provocative? Worth passing on?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Relevant and/or appealing content is also likeable. How do you create relevant and/or appealing content? Do you observe your fan’s eyes, hearts and minds? What keeps them coming back to your Page for more? Do you know what they like about you (or your Page)? Do you know what interests them?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whether it is humor, provocation or enticement, Guerrilla Facebook Marketers always aim to create high quality, likeable content. Creating likeable content is never easy to do, but it certainly goes a long way to get your fans to return for more.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("3. Ongoing Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrillas roll out their Facebook Marketing attack as an ongoing one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We say ongoing – it is not just about being current or present. It is about keeping the attack going. A Guerrilla Facebook Marketing attack can be dynamic: there could drastic, tactical changes, there could be lull periods, and there could be periods of extreme activity . . . the bottomline is, the attack never stops. Guerrillas focus their resources on maintaining an ongoing attack. We are talking weeks, if not months, or years even.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having a Facebook Page is not the same as having a corporate website. Your business’ website would probably contain information that does not change over time – for instance, your background history, business philosophy, and to a lesser degree, your products or services.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your Facebook presence, however, requires a totally different strategy. An ongoing attack is an intense one. Regularity breeds familiarity, and familiarity creates trust. Trust creates profitable sales from lifelong customers. For instance, your Facebook Page needs to be updated regularly. It doesn’t make much sense if half of the 955 million Facebook users log in to Facebook every "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("day, but you are only interested to connect with your fans once a month.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guerrilla Facebook Marketing is not for everybody. It is hard work to maintain an ongoing attack at all times. It could cost you nothing to set up a Facebook page. But it will cost you some resources to maintain the Page on a regular basis. You will need resources to maintain an ongoing attack.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("4. Real-Time Sensitivity")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Facebook is about being present in real-time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It focuses on being connected to those who are present with your Page in that moment. Over time, your fans would come and go, connecting with you at different times of the day, month or even year, but each time they do, they are connecting with you in real-time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guerrillas know that operating in a real-time environment means setting aside sufficient resources to engage in follow-up and being responsive in real-time to their fans. Take for instance, maintaining a Discussion Board on Facebook. Part of the real-time culture of the Facebook is the ubiquitous real-time stamp element of every status update, question or photo posed on your Page. Imagine: a sticky question is posed, and fans’ comments are flooding in by the minute. What do you think are the implications of posting a response that is time-stamped six months later?")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("5. Millions of Daily Active Users")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrilla Marketers know that they are not the only show in town.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are a lot of people connecting on Facebook each and every day – literally millions! This is the main draw why marketers are keen to jump on the Facebook bandwagon. It is irresistible for any marketer to ignore the attractiveness of having an audience this "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("size. We guerrillas agree too. Facebook has the capacity to reach out to many. But this is where the misunderstandings arise. Yes, Facebook can connect you to millions, but no, this does not happen automatically – at least not without effort on your part.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Getting someone’s attention on Facebook is much harder than you think. There is a lot of noise generated from other sources: friends, fans, businesses and of course, competitors. How do you stand out from the noise? What would make fans return to your Facebook Page, day after day?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guerrillas also know that despite the numbers, connecting with fans is still very much a one-on-one game. Every customer is an individual, and every individual desires to be treated as unique when they log into Facebook. What will make your fans feel extra special?")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("6. Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrillas want choice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Choice enables flexibility. And Facebook offers it – plenty of choice and flexibility. Unlike the other social media tools such as blogs or YouTube that have a limited range of tools, Facebook has, by far, the widest range and depth of weapons and ammo for businesses to choose from.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This gives businesses the flexibility to choose whether they want to launch a targeted marketing attack based on specific demographics (e.g. age, gender, birthday, location, relationships or even interests), or whether they want to reach out to as many fans and visitors as possible within the shortest time frame on a global scale.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("7. Data & Content Sharing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrillas would happily leverage on someone else’s data, as long as the job’s done well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("On the surface, Facebook may be a social tool, but the real value guerrillas look for is what runs beneath. Every comment, sharing, upload and click on Facebook is traceable and monitored carefully. And the good news is, Facebook takes it upon themselves to carry out the gruelling work of data collection and processing. And that is not all. Facebook shares their data openly with businesses and marketers. The shared data is a treasure trove of information that is not limited to demographics, geography, friends, spending habits and Facebook activities . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plus, there is more: not only is data access easy, data analysis is also made easy with the range of analytics offered by Facebook and third party vendors. No more muck or fuss to get the market research done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Content sharing refers to user-generated content (UGC) that fans and visitors post to Pages. This is how fans interact with businesses to connect with them, sharing their stories, their opinions, their reviews, and so on. UGC provides guerrillas with another minefield of data for processing.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("8. The Changing Face of Facebook")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrillas keep one eye open for what’s next.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Facebook is constantly evolving. It is constantly changing its policies and the way things are done or presented. It is constantly working with developers to roll out new tools or features for businesses and users alike. Put another way, you could say that the business mode of Facebook is change and evolution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guerrillas know this. They prepare themselves for a steady slew of changes that would come their way while they navigate the Facebook landscape. But while guerrillas stay vigilant for what’s next, they also approach change in moderation. They take time to sieve value from hype. When battling in the forest, they are aware of "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("the danger of missing the forest for the trees by chasing down every other shiny new gadget or app that Facebook launches.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("9. Social Enterprise")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When there are hundreds – or thousands – of fans, Guerrillas ask, “so what now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You are running a business. You did not create your business Page as a purely social activity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Who is buying what you are selling?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the day, having a strong fan base is not enough. There’s still plenty of work to be done. It might cost basically nothing to set up a Facebook Page, but having a Facebook Page alone isn’t going to magically ring in sales for your business. This is how business Pages in Facebook do not reach their full potential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You still need to bridge the gap by converting your Facebook activities into solid action that would help you achieve your business goals. If it is to explore new markets, are you doing consistent recon to detect which combinations of weapons work for you? If it is to expand your online presence, are you monitoring to assess if your Facebook Page is generating traffic that leads to your business website and vice-versa? If it is sales conversions you want, do you have a battle plan to convert your fans into customers? If it is about sales generation, do you have a battle plan to get your fans to buy?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To lose track of the entrepreneurial aspect of this social tool, is to lose the war.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("10. Facebook Connections")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Guerrillas recognise the value of fraternizing with the enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In business, what appears to be the enemy may not necessarily be so. If you change the way you view your competitors, your "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("competitor could well turn out to be a co-operator instead. In recent times, Facebook has embraced this concept as part of their business strategy. As a whole, Facebook has been reaching out aggressively to the web community in general, offering links from external websites to Facebook Pages (and vice-versa), among other collaborations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Facebook makes it easier for other online communities to interact with Facebook Pages and Profiles, we guerrillas are excited about the prospects of these connections. We can see how there’s going to be plenty of positive side-effects, such as a boom in fusion marketing. To fuse is to focus on cooperation rather than competition. For example, while at the supermarket, you receive discount coupons for lunchtime specials to the diner next door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("While attributes are features or qualities that are regarded as characteristics of Facebook, attitudes can be viewed as winning strategies that guerrillas adopt to drive their marketing attacks. Here’s our list of ten attitudes guerrilla Facebook marketers to be aware of:")]), _vm._v(" "), _c('p', {
    staticClass: "h1a",
    attrs: {
      "id": "ch1-sec2"
    }
  }, [_c('strong', [_vm._v("Attitudes of Guerrilla Facebook Marketers")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("1. Sincere.")]), _vm._v(" Guerrillas know that to engage in authentic conversations is to be sincere about engaging and connecting with their customers. Although guerrillas measure success in terms of net profits, they generate those profits by deploying relationship-building strategies such as providing advice or helping to build trust with their Facebook Fans. Sincerity is an integral part of a guerrilla’s Facebook marketing process. They genuinely want to know what their customers want in order to provide it for them. So they rely less on market research and more on personal contact they get on Facebook from their fans. "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Without sincerity, guerrillas know that their emails will stink like spam.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("2. Creative.")]), _vm._v(" Guerrillas need creativity to generate new content. From time to time, they could resort to rehashing content from elsewhere (such as from existing blogs or corporate websites), but from time to time, they will still need batches of fresh, creative and new content. They also need to be creative when it comes to managing negative feedback, or tackling new technologies and changes that would come their way in Facebook land.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("3. Patient.")]), _vm._v(" Guerrillas are aware that customers desire relationships, but relationships do not happen overnight, and there is a need to keep the attack going. Plus, some customers have been stung before, and they don’t want to be stung again. So it is going to take time to connect with their fans and visitors. How long? We say guerrillas need to give their Facebook marketing efforts at least two months to a year. Incidentally but definitely not coincidentally, patience is a time-honored guerrilla virtue.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("4. Relevant.")]), _vm._v(" Guerrillas stay ahead of the game by keeping themselves updated on what their fans want. They tell their fans the kind of stories their fans want to hear, to keep them coming back for more. Guerrillas also keep up with changing technologies. The web is a place filled with opportunities for self-learning. If guerrillas don’t know it, they learn it. This is how guerrillas stay relevant to the game.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("5. Dedicated.")]), _vm._v(" Guerrillas stick to their plan and persevere. There’s going to be plenty of distractions and they know it. If they are committed but lack dedication to see through the plan, they know it is not going to work. It’s not just "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("going to take a while to build up a fan base; it is also going to be rough as they deal with negative comments, reviews, or bad press from their fans-turned-detractors.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("6. Respectful.")]), _vm._v(" Guerrilla Marketers have long discerned that gone are the days of sales gimmicks, empty promises and cheesy ads. Guerrilla Marketing has an obligation to put money into your coffers, not just smiles - or looks of horror or shock or disgust - on the faces of your prospects. Facebook Fans are intelligent and discerning – they seek to be respected.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("7. Dependent.")]), _vm._v(" Guerrillas are aware that it is a fool’s errand to work alone. They know the outcome of their campaigns is strengthened by their collaborations with their fusion partners and suppliers, the commitment of their employees, and the loyalty of their customers. In other words, they are dependent on the community in which they operate in.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("8. Focused.")]), _vm._v(" Guerrillas keep focused on delivering their marketing plan. Maintaining focus sounds easy but it is not easy to achieve in a cluttered world filled with many distractions. This is why they shy away from shiny distractions such as trying out every new gadget or app released on Facebook.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("9. Confident.")]), _vm._v(" Guerrillas know they are the experts when it comes to their business. No one knows their business better than themselves, and when the moment is right, they are not afraid to show it, both on their Facebook Pages as well as on other online sites, such as forums or discussions.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('strong', [_vm._v("10. Direct.")]), _vm._v(" Guerrillas strive to be straight up about who they are, and what their business is about. They are proud of their unique selling point. If they feel they cannot afford to be honest and direct, then they won’t get involved in the "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("first place. They’d rather try other tools that could be more suited for them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Now take a couple of minutes to consider how attributes of Facebook are linked to attitudes of guerrillas:")]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "tab1"
    }
  }, [_vm._v("Table 1: Attributes & Attitudes")]), _vm._v(" "), _c('table', {
    staticClass: "border",
    attrs: {
      "border": "0",
      "cellpadding": "5",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Attributes of Facebook")])])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "middle"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Attitudes of Guerrilla"), _c('br'), _vm._v("Facebook Marketers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Authentic Conversations")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Sincere")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. Likeable Content")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. Creative")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. Ongoing Attack")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. Patient")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("4. Real-time Sensitivity")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("4. Relevant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("5. Millions of Daily Active Users")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("5. Dedicated")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("6. Choice")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("6. Respectful")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("7. Data & Content Sharing")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("7. Dependent")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("8. The Changing Face of Facebook")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("8. Focused")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("9. Social Enterprise")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bot1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("9. Confident")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bot2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("10. Facebook Connections")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("10. Direct")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3574bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 81
// module chunks = 0